import { ListViewData } from '@y42/core/list-view';
import {
  AbstractFeatureEntityState,
  AbstractFeatureStoreModel,
  AbstractFeatureUIModel,
  UserRelatedData,
} from '@y42/feature';
import { getJSONSchemaURL, Y42MetadataGitModel } from '@y42/feature/json-schema';
import {
  DataLineageLink,
  DataLineageNode,
  DataLineageSelectedFilter,
  DataLineageVisualNode,
  LineageSettings,
} from '@y42/json-schema';
import { DataLineageDiagramGitModel } from '../data-lineage-diagram';

export class DataLineageSettingsGitModel extends LineageSettings {
  constructor(model: DataLineageStoreModel) {
    super();
    this.$schema = getJSONSchemaURL('lineage-settings');
    this.linkDataArray = model.linkDataArray;
    this.nodeDataArray = model.nodeDataArray;
    this.visualDataArray = model.visualDataArray;
    this.selectedFilters = model.selectedFilters;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class DataLineageStoreModel extends Y42MetadataGitModel implements AbstractFeatureStoreModel {
  constructor(model: DataLineageStoreModel) {
    super(model);

    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;

    this.linkDataArray = model.linkDataArray;
    this.nodeDataArray = model.nodeDataArray;
    this.visualDataArray = model.visualDataArray;
    this.selectedFilters = model.selectedFilters;
  }

  $name: string;
  $path: string;
  $level: number;
  linkDataArray: DataLineageLink[];
  nodeDataArray: DataLineageNode[];
  visualDataArray: DataLineageVisualNode[];
  selectedFilters?: DataLineageSelectedFilter[];
}

export type DataLineageUIModel = AbstractFeatureUIModel & DataLineageStoreModel & Partial<UserRelatedData>;

export type DataLineageListViewData = ListViewData<DataLineageUIModel>;

export type DataLineageState = AbstractFeatureEntityState<DataLineageStoreModel>;

export interface CreateDataLineageParams {
  title: string;
  description: string;
  lineageDiagramUIModel: DataLineageDiagramGitModel;
  selectedFilters?: DataLineageSelectedFilter[];
}

export const DEFAULT_LINEAGE_SNAPSHOT = 'latest';
